export default "__VITE_ASSET__CqPrM$ty__"